(() => {
  function init() {
    document.querySelectorAll('[data-cmp]').forEach(root => {
      const g = window.gsap, ST = window.ScrollTrigger;
      const lit = on => root.classList.toggle('is-lit', on);
      if (!g || !ST || matchMedia('(prefers-reduced-motion: reduce)').matches) { lit(true); return; }
      g.registerPlugin(ST);

      // Sol: kağıt kartlar çöpe düşer
      const bin = root.querySelector('.cmp__bin');
      const papers = [...root.querySelectorAll('.cmp__paper')];
      const land = [
        { x: -34, y: 4, r: -14, fx: -90, fr: -70, rx: 70, ry: -40 },
        { x: 30, y: -6, r: 10, fx: 110, fr: 85, rx: -60, ry: 50 },
        { x: -4, y: 10, r: -3, fx: -40, fr: -120, rx: 80, ry: 30 },
        { x: 38, y: 14, r: 19, fx: 70, fr: 140, rx: -75, ry: -55 },
        { x: -28, y: 18, r: 7, fx: -120, fr: 60, rx: 55, ry: 65 }
      ];
      const tl1 = g.timeline({ scrollTrigger: { trigger: root.querySelector('.cmp__stage--old'), start: 'top 82%', end: 'bottom 38%', scrub: 1 } });
      papers.forEach((p, i) => {
        const L = land[i % land.length], at = i * 0.5;
        tl1.fromTo(p,
          { x: L.fx, y: -560, rotation: L.fr, rotationX: L.rx, rotationY: L.ry },
          { x: L.x, y: L.y, rotation: L.r, rotationX: 0, rotationY: 0, duration: 1, ease: 'power2.in' }, at)
          .to(bin, { keyframes: [{ rotation: i % 2 ? 1.6 : -1.6, duration: 0.07 }, { rotation: i % 2 ? -1 : 1, duration: 0.07 }, { rotation: 0, duration: 0.1 }], ease: 'sine.out' }, at + 1);
      });

      // Sağ: NFC kart telefona dokunur
      const stage = root.querySelector('.cmp__stage--new');
      const card = stage.querySelector('.cmp__nfc'), phone = stage.querySelector('.cmp__phone');
      const tl2 = g.timeline({ scrollTrigger: { trigger: stage, start: 'top 78%', end: 'bottom 42%', scrub: 1 } });
      tl2.fromTo(phone, { y: 50 }, { y: 0, duration: 1, ease: 'power2.out' }, 0)
        .fromTo(card,
          { y: -330, x: 70, rotation: -34, rotationX: 62, rotationY: -24 },
          { y: 0, x: 0, rotation: -10, rotationX: 14, rotationY: 0, duration: 1.1, ease: 'power2.inOut' }, 0)
        .addLabel('tap')
        .to(card, { y: 5, rotationX: 4, duration: 0.1, ease: 'power1.in' })
        .to(phone, { y: 3, duration: 0.1, ease: 'power1.in' }, '<')
        .to(card, { y: -16, rotationX: 18, duration: 0.5, ease: 'power2.out' })
        .to(phone, { y: 0, duration: 0.4, ease: 'power2.out' }, '<')
        .to(card, { y: -10, duration: 0.4, ease: 'sine.inOut' });
      const sync = () => lit(tl2.time() >= tl2.labels.tap);
      tl2.eventCallback('onUpdate', sync); sync();
    });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
